<div class="container-fluid h-100 pe-0">
  <div class="h-100 p-0">
    <app-sidebar class="bg-light overflow-auto"></app-sidebar>
    <router-outlet class="d-none"></router-outlet>
  </div>
</div>
